// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Container: 'container',
	StarIcon: 'star-icon',
	KebabOptions: 'kebab-options',
	Pill: 'pill',
	Pill1: 'pill-1',
	Pill2: 'pill-2',
	Pill3: 'pill-3',
	Pill4: 'pill-4',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
